import React from 'react';

const GOLD = '#ebb51b';
const GRAY = '#9a9ca1'; // Grigio bilanciato per far risaltare l'oro sullo sfondo scuro

export const ContattiIcon = ({ size = 32, className = "" }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Utente Secondario (Sfondo) - Grigio */}
      <circle cx="15.5" cy="7.5" r="3.5" fill={GRAY} opacity="0.75" />
      <path
        d="M12.5 19v-0.8c0-2 1.6-3.7 3.6-3.7h1.8c2 0 3.6 1.7 3.6 3.7v0.8c0 0.6-0.4 1-1 1h-7c-0.6 0-1-0.4-1-1z"
        fill={GRAY}
        opacity="0.75"
      />

      {/* Utente Principale (Primo piano) - Oro Pieno */}
      <circle cx="8.5" cy="7.5" r="4" fill={GOLD} />
      <path
        d="M3 19v-1c0-2.5 2-4.5 4.5-4.5h2c2.5 0 4.5 2 4.5 4.5v1c0 0.8-0.7 1.5-1.5 1.5h-8c-0.8 0-1.5-0.7-1.5-1.5z"
        fill={GOLD}
      />
    </svg>
  );
};

export default ContattiIcon;